export default function Navbar () {
    return (
        <div className="navbar">
            <a className="navbar-item" href="#gallery">Gallery</a>
            <a className="navbar-item" href="#flavours">Flavours</a>
            <a className="navbar-item" href="#shops">Shops</a>
        </div>
    )
};